import React, {Component} from 'react';

export default class ExhibitionEntry extends Component {
  render() {
    return (
      <tr>
        <td><img src={ this.props.data.imageSrc ? `${ this.props.data.imageSrc }` : "/images/exhibition_placeholder.png"} width="100" height="75" className="App-sceneImage" /></td>
        <td>{ this.props.data.name }</td>
        <td className="mobile-hide">{ this.props.data.location }</td>
        <td>{ this.props.data.city }, { this.props.data.country }</td>
        <td className="mobile-hide">{ this.props.data.date }</td>
        <td className="mobile-hide"><a href={`${ this.props.data.locationUrl }`} target="_blank" className="button">📍 Map</a></td>
        <td><a href={`${ this.props.data.eventUrl }`} target="_blank" className="button">Visit Page</a></td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/exhibitionEntry.js